import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import CustomerApp from './customer/CustomerApp';
import RestaurantApp from './restaurant/RestaurantApp';
import CustomerShell from './customer/CustomerShell';
import BillViewPage from './customer/BillViewPage';

function App() {
  const appMode = process.env.REACT_APP_MODE || 'customer';
  
  return (
    <Router>
      <Routes>
        {/* Legacy customer app entry */}
        <Route path="/customer/*" element={<CustomerApp />} />

        {/* Public bill view */}
        <Route path="/bill/:shareToken" element={<BillViewPage />} />

        {/* Universal QR entry: /menu/:restaurantId */}
        <Route path="/menu/:restaurantId/*" element={<CustomerShell variant="universal" />} />

        <Route path="/restaurant/*" element={<RestaurantApp />} />
        <Route 
          path="/" 
          element={<Navigate to={appMode === 'restaurant' ? '/restaurant' : '/customer'} replace />} 
        />
      </Routes>
    </Router>
  );
}

export default App;

